export const notifyError = ({ addNotification, message }) => addNotification({
  type: 'danger',
  position: 'top-right',
  text: message,
  removeAfter: 6000,
});
